import Botox from "../";

const routes = [{ name: "Home Botox", path: "/homebotox", component: Botox.HomeBotoxList, meta: { title: "Home Botox" } }];

export default routes;
